var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"title"},[_vm._v("404")]),_c('div',{staticClass:"permissions"},[_vm._v("很抱歉，沒有此頁面")]),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回主頁")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }